<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="" class="fn-left">
            <el-input
              v-model="listQuery.phone"
              placeholder="请输入家长手机号"
            />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-input
              v-model="listQuery.trade_no"
              placeholder="请输入交易单号"
            />
          </el-form-item>
          <el-form-item class="fn-left">
            <el-date-picker
              v-model="listQuery.begin_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
            />
            <i class="split-time">至</i>
            <el-date-picker
              v-model="listQuery.end_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetOrderList">查询</el-button>
            <span style="color:#409EFF;font-size: 16px;margin-left:20px">总计：{{ totalAmount/100 }} 元</span>
          </el-form-item>

        </el-form>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="充值时间" prop="create_time" align="center" />
        <el-table-column label="订单编号" prop="out_trade_no" align="center" />
        <el-table-column label="财务单号" prop="trade_no" align="center" />
        <!-- <el-table-column label="家长手机" prop="phone" align="center" /> -->
        <el-table-column label="充值金额" align="center">
          <template slot-scope="{row}">
            <span>{{ row.amount/100 }}元</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="listQuery.p"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
          :page-size="listQuery.limit"
          @current-change="fnGetOrderList"
        >
          <div class="chax">
            {{ listQuery.p }}/{{
              total > 0 ? Math.ceil(total / listQuery.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ total }}条</i>
          </span>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
var moment = require('moment')

export default {
  name: 'ChargeOrderList',
  components: {},
  data() {
    return {
      selectList: [],
      lists: [],
      tableKey: 0,
      total: 0,
      totalAmount: 0,
      listQuery: {
        p: 1,
        limit: 20,
        phone: '',
        trade_no: '',
        begin_time: moment().format('YYYY-MM-DD'),
        end_time: moment().format('YYYY-MM-DD')
      }
    }
  },
  created() {
    this.fnGetSelectList()
    this.fnGetOrderList()
  },
  methods: {
    fnGetOrderList: function() {
      this.$http.resetRecord(this.listQuery).then(res => {
        this.tableKey++
        this.lists = res.data.list
        this.totalAmount = parseInt(res.data.totalAmount || '0')
        this.total = parseInt(res.data.count)
      })
    },
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.selectList = res.data
      })
    }
  }
}
</script>
<style lang="scss" scope>
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
